import React, { useState } from "react";
import { Modal, Input } from "antd";
import "./unsubscribe.scss";
import unsbscribe_img from "../../assets/images/unsbscribe.svg";
import gatekeeper_logo from "../../images/getkeeper_logo.png";
import Title from "antd/es/skeleton/Title";
import Loading from "../common/Loading/loading";

const UnsbscribeComponent = (props) => {
  const { handleSubmit, handleUnsubscribe, validation, handelotp, loading } =
    props;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formData, setFormData] = useState({
    phone_number: "",
    code: "",
  });

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    handleSubmit();
    setFormData({ phone_number: "", code: "" });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="unsbscribe">
      <div className="unsbscribe-img-left">
        <img src={unsbscribe_img} alt="" />
      </div>
      <div className="unsbscribe-right-content">
        <div className="unsbscribe-right">
          <img
            src={gatekeeper_logo}
            alt="gatekeeper_logo"
            className="society-logo"
          />
          <h4 className="register-text">
            Please Enter Your Details And Click The Button Below To Confirm
            Unsubscribe.
          </h4>

          <div className="unsbscribe-form">
            <p>Mobile no</p>
            <Input
              size="large"
              className="input-field"
              placeholder="Enter Mobile Number"
              name="phone_number"
              type="tel"
              value={formData.phone_number}
              onChange={(event) => {
                handleInputChange(event);
                handleUnsubscribe(event); 
              }}
              onInput={(event) => {
                event.target.value = event.target.value.replace(/\D/g, "");
              }}
              maxLength={10}
              prefix={
                <span style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/4/41/Flag_of_India.svg"
                    alt="India Flag"
                    style={{ width: 20, height: 15, marginRight: 5 }}
                  />
                  <span>+91</span>
                </span>
              }
            />
            {validation.phone_number && (
              <p
                style={{ color: "red", paddingBottom: "3px", fontSize: "14px" }}
              >
                {validation.phone_number}
              </p>
            )}
          </div>
          <div className="unsbscribe-form">
            <p>Enter Pin</p>

            <div className="enter-otp-main">
              <Title level={3}>With custom display character</Title>
              <Input.OTP
                length={4}
                value={formData.code}
                onChange={(event) => {
                  setFormData((prev) => ({
                    ...prev,
                    code: event,
                  }));
                  handelotp(event);
                }}
                name="code"
                type="number"
                inputMode="numeric"
                style={{
                  WebkitTextSecurity: "disc",
                }}
              />
            </div>
            {validation.code && (
              <p
                style={{ color: "red", paddingBottom: "3px", fontSize: "14px" }}
              >
                {validation.code}
              </p>
            )}
          </div>
          <button className="unsbscribe-button" onClick={showModal}>
            {loading ? <Loading type="spinner" color="#fff" /> : "Unsubscribe"}
          </button>
          <p className="unsbscribe-last-text">
            We're sorry to see you go! If you unsubscribe, you will no longer
            receive updates and notifications from us. If you change your mind,
            you can always resubscribe later. Thank you for being a part of our
            community!
          </p>
        </div>
      </div>

      <Modal
        title="Before You Go..."
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Yes, Unsubscribe"
        cancelText="Cancel"
      >
        <p>
          We're truly sad to see you leave. 😢 If you ever decide to come back,
          we'll welcome you with open arms! 💙
        </p>
        <p>Are you sure you want to unsubscribe?</p>
      </Modal>
    </div>
  );
};

export default UnsbscribeComponent;
